module.exports = __webpack_public_path__ + "static/media/blrss2.7a4bda09.png";